"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enable = void 0;
exports.clear = clear;
exports.getDOMStorageItems = getDOMStorageItems;
exports.removeDOMStorageItem = removeDOMStorageItem;
exports.setDOMStorageItem = setDOMStorageItem;
var safeStorage_1 = __importDefault(require("licia/safeStorage"));
var each_1 = __importDefault(require("licia/each"));
var isStr_1 = __importDefault(require("licia/isStr"));
var once_1 = __importDefault(require("licia/once"));
var jsonClone_1 = __importDefault(require("licia/jsonClone"));
var connector_1 = __importDefault(require("../lib/connector"));
var detectBrowser_1 = __importDefault(require("licia/detectBrowser"));
var localStore = (0, safeStorage_1.default)('local');
var sessionStore = (0, safeStorage_1.default)('session');
var browser = (0, detectBrowser_1.default)();
function clear(params) {
    var store = getStore(params.storageId);
    store.clear();
}
function getDOMStorageItems(params) {
    var store = getStore(params.storageId);
    var entries = [];
    (0, each_1.default)((0, jsonClone_1.default)(store), function (val, key) {
        if (!(0, isStr_1.default)(val))
            return;
        entries.push([key, val]);
    });
    return {
        entries: entries,
    };
}
function removeDOMStorageItem(params) {
    var key = params.key, storageId = params.storageId;
    var store = getStore(storageId);
    store.removeItem(key);
}
function setDOMStorageItem(params) {
    var key = params.key, value = params.value, storageId = params.storageId;
    var store = getStore(storageId);
    store.setItem(key, value);
}
exports.enable = (0, once_1.default)(function () {
    if (browser.name === 'ie') {
        return;
    }
    (0, each_1.default)(['local', 'session'], function (type) {
        var store = type === 'local' ? localStore : sessionStore;
        var storageId = getStorageId(type);
        var originSetItem = store.setItem.bind(store);
        store.setItem = function (key, value) {
            if (!(0, isStr_1.default)(key) || !(0, isStr_1.default)(value))
                return;
            var oldValue = store.getItem(key);
            originSetItem(key, value);
            if (oldValue) {
                connector_1.default.trigger('DOMStorage.domStorageItemUpdated', {
                    key: key,
                    newValue: value,
                    oldValue: oldValue,
                    storageId: storageId,
                });
            }
            else {
                connector_1.default.trigger('DOMStorage.domStorageItemAdded', {
                    key: key,
                    newValue: value,
                    storageId: storageId,
                });
            }
        };
        var originRemoveItem = store.removeItem.bind(store);
        store.removeItem = function (key) {
            if (!(0, isStr_1.default)(key))
                return;
            var oldValue = store.getItem(key);
            if (oldValue) {
                originRemoveItem(key);
                connector_1.default.trigger('DOMStorage.domStorageItemRemoved', {
                    key: key,
                    storageId: storageId,
                });
            }
        };
        var originClear = store.clear.bind(store);
        store.clear = function () {
            originClear();
            connector_1.default.trigger('DOMStorage.domStorageItemsCleared', {
                storageId: storageId,
            });
        };
    });
});
function getStorageId(type) {
    return {
        securityOrigin: location.origin,
        isLocalStorage: type === 'local',
    };
}
function getStore(storageId) {
    var isLocalStorage = storageId.isLocalStorage;
    return isLocalStorage ? localStore : sessionStore;
}
